import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { SERVICE_GROUPS } from "../../data/navigation";
import { CtaLink } from "../ui/CtaLink";
export function MegaMenu({
  onNavigate
}: {
  onNavigate: () => void;
}) {
  return <motion.div id="services-menu" initial={{
    opacity: 0,
    y: -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -6
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} className="absolute inset-x-0 top-full border-b border-line bg-ink/95 backdrop-blur-xl" data-id="element-319" data-mp="ictexatsit3u">
      <div className="shell grid gap-10 py-10 xl:grid-cols-[repeat(3,minmax(0,1fr))_minmax(260px,0.8fr)]" data-id="element-320" data-mp="161cmtp8xh3ve">
        {SERVICE_GROUPS.map(group => <div key={group.title} data-id="element-321" data-mp="37u0o3t20hh8j">
            <p className="t-eyebrow mb-4 text-muted" data-id="element-322" data-mp="37v21i46i2ftf">{group.title}</p>
            <ul className="grid gap-1" data-id="element-323" data-mp="32v5zgahd4ygi">
              {group.items.map(item => <li key={item.href} data-id="element-324" data-mp="14gf37wr0eiby">
                  <Link to={item.href} onClick={onNavigate} className="group flex items-start gap-3 rounded-xl p-2.5 transition-colors duration-150 ease-out hover:bg-white/5" data-id="element-325" data-mp="14hgeo2bxt6u7">
                    <item.icon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-accent-soft" aria-hidden data-id="element-326" data-mp="1ecqjsyxmtuc7" />
                    <span data-id="element-327" data-mp="1n6ws1q8q0ts1">
                      <span className="block text-[15px] font-medium text-fg" data-id="element-328" data-mp="1n7oby3syh32h">{item.label}</span>
                      <span className="block text-[13px] text-muted" data-id="element-329" data-mp="1s56mtzqj9sd4">{item.blurb}</span>
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>)}
        <div className="flex flex-col justify-between rounded-2xl border border-line bg-ink-3 p-6" data-id="element-330" data-mp="222ujwwbm3byg">
          <div data-id="element-331" data-mp="2scy3kklmgmv">
            <p className="font-display text-xl font-semibold tracking-tight" data-id="element-332" data-mp="2sw5i7cmhmmn">Not sure what you need?</p>
            <p className="mt-2 text-sm text-muted" data-id="element-333" data-mp="7qeg026ag9wr">Tell us about your business and we'll recommend the right setup — with a fixed price in writing.</p>
          </div>
          <div className="mt-6 flex flex-col gap-2" data-id="element-334" data-mp="3qwt4erxrjcbe">
            <CtaLink to="/contact" track="megamenu_request" className="w-full" data-id="element-335" data-mp="3qy47epjdwg1g">
              Request a Website <ArrowRightIcon className="h-4 w-4" data-id="element-336" data-mp="9l9wnnfayc91" />
            </CtaLink>
            <Link to="/services" onClick={onNavigate} className="py-2 text-center text-sm text-fg-2 hover:text-fg" data-id="element-337" data-mp="4n8b8vuem0ue">
              View all services
            </Link>
          </div>
        </div>
      </div>
    </motion.div>;
}